"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when some of the class deletions in a batch delete fail
 * @param {AdminBatchDeleteClassesFailedClass[]} failedClasses
 */
class AllClassDeletionsDidNotSucceedError extends client_library_1.ExtendableError {
    constructor(failedClasses) {
        super(failedClasses
            .map(failedClass => `Class: ${failedClass.classId} failed to delete. Error: ${failedClass.error}`)
            .join('\n'));
        this.failedClasses = failedClasses;
    }
}
exports.default = AllClassDeletionsDidNotSucceedError;
//# sourceMappingURL=AllClassDeletionsDidNotSucceedError.js.map